import React from "react";

import "./index.scss";

const SectionCard = ({ title, titleElement, icon, legend, onContentBorder, children }) => {
  const hasHeader = Boolean(title || titleElement || legend);

  return (
    <div className="section-card">
      {hasHeader && (
        <div className="section-card-header">
          <div className="section-card-header-main">
            {titleElement && titleElement}
            {title && !titleElement && (
              <div className="section-card-title">
                {icon && icon}
                <span className="section-card-title-text">{title}</span>
              </div>
            )}
          </div>

          {legend && <div className="section-card-legend">{legend}</div>}
        </div>
      )}

      <div className={`section-card-content ${onContentBorder ? "no-border" : ""}`}>{children}</div>
    </div>
  );
};

export default SectionCard;
